import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getCartTesterProducts } from "@src/store/slices/checkoutBlocks/selectors";
import {
  openProductPicker,
  setProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const openTestCartProductPicker = createAsyncThunk<void, string>(
  "productPicker/openTestCartProductPicker",
  async (variationId, { dispatch, getState }) => {
    const cartTesterProducts = getCartTesterProducts(variationId)(getState());

    dispatch(
      openProductPicker({
        type: "cartTester",
        variationId,
      })
    );

    const productMap = new Map<string, ProductPickerSelectedProduct>();

    cartTesterProducts.forEach((product) => {
      const existing = productMap.get(product.id);

      if (existing) {
        const combinedVariantIds = [
          ...(existing.selectedVariantIds || []),
          product.variantId,
        ];
        existing.selectedVariantIds = [...new Set(combinedVariantIds)];
      } else {
        productMap.set(product.id, {
          id: product.id,
          title: product.title,
          image: product.image,
          handle: "",
          requiresSellingPlan: product.requiresSellingPlan ?? false,
          selectedVariantIds: [product.variantId],
        });
      }
    });

    const selectedProducts: ProductPickerSelectedProduct[] = Array.from(
      productMap.values()
    );

    dispatch(setProductPickerSelectedProducts(selectedProducts));
  }
);
